import KidsWhitelistItem from "../Entities/KidsWhitelistItem";

export {KidsHTTPMapping as default};

/**
 * Maps Kid account data sent by the server into Kids Entities objects
 *
 * @author rsommerfeld <roni.s.sommerfeld@altice.pt>
 *
 * @since 7.0.0
 *
 * @private
 */
class KidsHTTPMapping {
  /**
   * Map submit Alias ​​field to KdisEntity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object.<KidsItem>}           data
   * @param {Object.<HTTPResponseEntity>} response
   *
   * @returns {void}
   */
  mapSubmitAlias(data, response){
    data.auth_parent_method = response.results.method;
  }

  /**
   * Map if parent is authenticated
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object.<KidsItem>}           data
   * @param {Object.<HTTPResponseEntity>} response
   *
   * @returns {void}
   */
  mapParentAuth(data, response){
    data.parent_authenticated = response.success;
  }

  /**
   * Map Kids Prefers
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object.<KidsItem>}           data
   * @param {Object.<HTTPResponseEntity>} response
   *
   * @returns {void}
   */
  mapKidsPrefs(data, response){
    data.authorized_action_emails = response.results.prefs.action || null;
  }

  /**
   * Map to Remove an email from the whitelist
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object.<KidsItem>}           data
   * @param {Object.<HTTPResponseEntity>} response
   *
   * @returns {void}
   */
  mapRemoveWhitelist(data, response){
    data.whitelist.delete(response.results.remove_email)
  }

  /**
   * Map Kids Whitelist server data
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object.<KidsItem>} data
   * @param {Object}            response_whitelist
   *
   * @returns {void}
   */
  mapKidsWhiteList(data, response_whitelist){
    if('active' in response_whitelist){
      data.whitelist_active = parseInt(response_whitelist.active);
    }

    if(response_whitelist.list){
      response_whitelist.list.forEach(item => {
        const whitelist = new KidsWhitelistItem;
        whitelist.email = item;

        data.whitelist.add(whitelist)
      })
    }
  }
}